import type { Currency } from '@witmetrics/utils';
import { formatCurrency } from '@witmetrics/utils/strings';
import NumberInput, {
  type NumberInputProps,
} from '@/components/inputs/NumberInput';

export interface PriceInputProps extends NumberInputProps {
  currency?: Currency;
}

export default function PriceInput({
  name = 'price',
  size = 'medium',
  label = 'Price',
  currency,
  ...props
}: PriceInputProps) {
  return (
    <NumberInput
      size={size}
      name={name}
      label={label}
      adornment={formatCurrency(currency)}
      {...props}
    />
  );
}
